import type { Definition } from '@exodus/dependency-types';

const getIsFavoriteDefinition = {
  id: 'favoriteAssets.selectors.getIsFavorite',
  factory: () => () => () => false,
} as const satisfies Definition;

export default getIsFavoriteDefinition;
